<ion-header>
  <ion-toolbar color="primary">
    <ion-title> Mimbo </ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <ion-grid class="no-padding grid">
    <ion-row>
      <ion-col sizeLg="6" offsetLg="3">
        <ion-img src="../../assets/images/HomeSlogan.jpg" class="slogan"></ion-img>
      </ion-col>
    </ion-row>
    <ion-row style="padding-top: 24px">
      <ion-col sizeLg="3" sizeMd="4" sizeXs="6" class="ion-text-center hover" routerLink="/reminders">
        <div class="square">
          <img src="../../../assets/images/menu/Appointment.jpg" />
        </div>
        <ion-text color="darkmimbo" class="page-name">Appointments & Reminders</ion-text>
      </ion-col>
      <ion-col sizeMd="4" sizeXs="6" sizeLg="3" class="ion-text-center hover" routerLink="/cases">
        <div class="square">
          <img src="../../../assets/images/menu/lost.jpg" />
        </div>
        <ion-text color="darkmimbo" class="page-name">Rescue Center</ion-text>
      </ion-col>
      <ion-col sizeMd="4" sizeXs="6" sizeLg="3" class="ion-text-center hover" routerLink="/doggogram">
        <div class="square">
          <img src="../../../assets/images/menu/doggogram.jpg" />
        </div>
        <ion-text color="darkmimbo" class="page-name">Pawstagram</ion-text>
      </ion-col>
      <ion-col sizeMd="4" sizeXs="6" sizeLg="3" class="ion-text-center hover" routerLink="/doggyhub">
        <div class="square">
          <img src="../../../assets/images/menu/doggyhub.jpg" />
        </div>
        <ion-text color="darkmimbo" class="page-name">PawHub</ion-text>
      </ion-col>
      <ion-col sizeMd="4" sizeXs="6" sizeLg="3" class="ion-text-center hover" routerLink="/recipelist">
        <div class="square">
          <img src="../../../assets/images/menu/recipe.jpg" />
        </div>
        <ion-text color="darkmimbo" class="page-name">Paw-some Recipes</ion-text>
      </ion-col>
      <ion-col sizeMd="4" sizeXs="6" sizeLg="3" class="ion-text-center hover" routerLink="/vets-near-by">
        <div class="square">
          <img src="../../../assets/images/menu/vets.jpg" />
        </div>
        <ion-text color="darkmimbo" class="page-name">Vets Near Me</ion-text>
      </ion-col>
      <ion-col sizeMd="4" sizeXs="6" sizeLg="3" class="ion-text-center hover" routerLink="/edible">
        <div class="square">
          <img src="../../../assets/images/menu/food.jpg" />
        </div>
        <ion-text color="darkmimbo" class="page-name">Can Paws Eat it?</ion-text>
      </ion-col>
      <ion-col sizeMd="4" sizeXs="6" sizeLg="3" class="ion-text-center hover" routerLink="/exercises">
        <div class="square">
          <img src="../../../assets/images/menu/pup-gym.jpg" />
        </div>
        <ion-text color="darkmimbo" class="page-name">The Paw Gym</ion-text>
      </ion-col>

      <ion-col sizeMd="4" sizeXs="6" sizeLg="3" class="ion-text-center hover" routerLink="/breeds-info">
        <div class="square">
          <img src="../../../assets/images/menu/info.jpg" />
        </div>
        <ion-text color="darkmimbo" class="page-name">Breeds Info</ion-text>
      </ion-col>

      <ion-col sizeMd="4" sizeXs="6" sizeLg="3" class="ion-text-center hover" routerLink="/donate">
        <div class="square">
          <img src="../../../assets/images/menu/donation.jpg" />
        </div>
        <ion-text color="darkmimbo" class="page-name">Make a Difference</ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>